module.exports = __webpack_public_path__ + "static/img/017.f354518a.png";